import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";

/**
 * Whether the vendor stats dashboard (and its show/hide toggle) render.
 *
 * Two halves:
 *   - a view gate — the dashboard lives on the reworked Manifests surface, so
 *     the tenant needs `manifest-views-v2` or `manifest-views-v3`. V3 renders
 *     the same dashboard, and a tenant can hold v3 without v2, so demanding v2
 *     alone drops the whole section for exactly the tenants v3 targets.
 *   - a data gate — `waste-epa-correction-discrepancies` gates the correction
 *     data every tile queries, so the dashboard never renders empty.
 *
 * Both view flags carry `staffOverride: true`, so `useFeatureFlags` resolves
 * them on for staff and no explicit `isStaff` check is needed here.
 *
 * The dashboard and its toggle both call this so their gates can't drift.
 */
export function useVendorDashboardEnabled(): boolean {
  const { featureFlags } = useFeatureFlags();
  const hasViewFlag =
    !!featureFlags[FeatureFlagKey.ManifestViewsV2] ||
    !!featureFlags[FeatureFlagKey.ManifestViewsV3];
  return hasViewFlag && !!featureFlags[FeatureFlagKey.WasteEpaCorrectionDiscrepancies];
}
